import React from 'react';

const IssueStatusStepper = ({ status }) => {
  const stages = [
    { key: 'reported', label: 'Reported' },
    { key: 'pending', label: 'Pending' },
    { key: 'accepted', label: 'Accepted' },
    { key: 'in_progress', label: 'In Progress' },
    { key: 'resolved', label: 'Resolved' },
    { key: 'closed', label: 'Closed' },
    { key: 'rejected', label: 'Rejected' }
  ];
  const currentIndex = Math.max(0, stages.findIndex(s => s.key === status));

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
      {stages.map((stage, idx) => {
        const done = idx <= currentIndex;
        return (
          <div key={stage.key} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{
              width: 12,
              height: 12,
              borderRadius: 999,
              background: done ? '#10b981' : '#e6eef7',
              border: done ? '2px solid #059669' : '2px solid #c9d9ee'
            }} />
            <div style={{ fontSize: 11, color: done ? '#064e3b' : '#475569' }}>{stage.label}</div>
            {idx < stages.length - 1 && <div style={{ width: 20, height: 2, background: idx < currentIndex ? '#10b981' : '#e6eef7', margin: '0 6px' }} />}
          </div>
        );
      })}
    </div>
  );
};

export default IssueStatusStepper;
